import React, { Suspense, lazy } from 'react';
import { Box } from '@mui/material';
import HeroSection from '../components/home/sections/HeroSection';
import CategorySidebar from '../components/home/sections/CategorySidebar';
import HomeFeaturedSection from '../components/home/sections/HomeFeaturedSection';
import HomeWhyKrillouSection from '../components/home/sections/HomeWhyKrillouSection';
import HomeHowItWorksSection from '../components/home/sections/HomeHowItWorksSection';
import HomePopularCategoriesSection from '../components/home/sections/HomePopularCategoriesSection';
import CTASection from '../components/home/sections/CTASection';
import ReassuranceBar from '../components/home/sections/ReassuranceBar';

const BestReviews = lazy(() => import('../components/home/sections/BestReviews'));

const SectionFallback = () => <Box sx={{ minHeight: 120 }} />;

const HomePage = () => {

  return (
    <Box sx={{ minWidth: 320, bgcolor: 'background.default' }}>
      {/* Category FAB sidebar — fixed position, always visible */}
      <CategorySidebar />

      {/* 1. Hero + Search */}
      <HeroSection />

      {/* 2. Featured listings + products — lightweight diversified grid */}
      <HomeFeaturedSection />

      {/* 3. Why Krillou */}
      <HomeWhyKrillouSection />

      {/* 4. How it works */}
      <HomeHowItWorksSection />

      {/* 5. Popular categories */}
      <HomePopularCategoriesSection />

      {/* 5.5 Reviews — lazy loaded */}
      <Suspense fallback={<SectionFallback />}>
        <BestReviews />
      </Suspense>

      {/* 6. CTA */}
      <CTASection />

      {/* 7. Reassurance */}
      <ReassuranceBar />
    </Box>
  );
};

export default HomePage;
